import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getMiscPurchaseOrderApiErrorMessage(error, fallback = '操作失敗') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (code === 'RESOURCE_NOT_FOUND') {
    return data?.message || '找不到非庫存採購單';
  }

  if (data?.message) {
    return data.message;
  }

  if (code) {
    return `${fallback}（${code}）`;
  }

  return fallback;
}

export function isMiscPurchaseOrderVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
